// src/app/utils/device-shadow.utils.ts

export class DeviceShadowUtils {
  static buildClearedDeviceConfigShadows(): any {
    return {
      device_meta: {
        name: null,
        version: null
      },
      ui: {
        data_routing_wired: null,
        routing: null  // remove old value
      },
      dhcp: {
        dns_servers: null,
        enabled: null,
        lease_time: null,
        local_domain: null,
        local_ipv4: null,
        local_ipv4_prefix: null,
        range_end: null,
        range_start: null,
        reservations: null
      },
      hostapd: {
        band_5ghz: null,
        channel: null,
        country: null,
        enabled: null,
        ssid: null,
        wpa_passphrase: null
      },
      modem_emulator: {
        baud: null,
        enabled: null,
        flow_control: null
      },
      net_mgr: {
        host_groups: null
      },
      platform: {
        cellular_enabled: null,
        iridium_sfx_data_enabled: null,
        iridium_sfx_enabled: null,
        serial_enabled: null,
        sos_enabled: null,
        battery_shutdown_time: null,
        skylink: null,    // remove old values
        iridium_sfx: null,  // remove old values
        serial: null // remove old values
      },
      sims: {
        sims: null
      },
      snmp: {
        community_ro: null,
        community_rw: null,
        enabled: null
      },
      firewall_dnat: {
        dnat: null
      },
      firewall_ipsets: {
        ipsets: null
      },
      remote_management: {
        call_history_enabled: null,
        call_history_interval: null,
        position_reports_enabled: null,
        position_reports_interval: null,
        remote_management_enabled: null,
        remote_management_interval: null,
        status_reports_enabled: null,
        status_report_interval: null,
        usage_upload_enabled: null,
        usage_upload_interval: null,
        shadow_interval: null,
        sos_report_interval: null,
        rtm_routing: null
      },
      messaging_hub: {
        rest_endpoint: null,
        channels: null,
        high_topic_id: null,
        standard_topic_id: null
      },
      videosoft: {
        enabled: null
      }
    };
  }

  static buildClearedVoiceConfigShadows(): any {
    return {
      voice_meta: {
        name: null,
        version: null
      },
      pbx: {
        dahdi_extensions: null,
        sip_extensions: null,
        tonezone: null
      }
    };
  }
}